import React from 'react';
import { Hero } from '../components/Hero';
import { ServicePillars } from '../components/ServicePillars';
import { ValueProposition } from '../components/ValueProposition';
import { Services } from '../components/Services';
import { TechStack } from '../components/TechStack';
import { Contact } from '../components/Contact';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { NexyomLogo } from '../components/NexyomLogo';
export function LandingPage() {
  return <div className="w-full" data-id="element-143">
      <Hero data-id="element-144" />

      {/* Featured Service Banner */}
      <Link to="/microsoft365" className="block" data-id="element-145">
        <section className="bg-blue-600 text-white py-4 relative overflow-hidden group cursor-pointer" data-id="element-146">
          <div className="absolute inset-0 bg-black/10 transition-opacity group-hover:bg-black/0" data-id="element-147" />
          <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-4 relative z-10" data-id="element-148">
            <span className="font-bold tracking-wide uppercase text-sm md:text-base" data-id="element-149">
              Nouveau Service
            </span>
            <div className="h-4 w-px bg-white/30" data-id="element-150" />
            <span className="font-medium md:text-lg" data-id="element-151">
              Migration & Sécurisation Microsoft 365
            </span>
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-152" />
          </div>
        </section>
      </Link>

      <ServicePillars data-id="element-153" />
      <ValueProposition data-id="element-154" />
      <Services data-id="element-155" />
      <TechStack data-id="element-156" />
      <Contact data-id="element-157" />

      <footer className="bg-black text-white py-16 border-t border-white/10" data-id="element-158">
        <div className="max-w-6xl mx-auto px-6" data-id="element-159">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-160">
            <NexyomLogo variant="full" colorScheme="dark" size="sm" data-id="element-161" />
            <p className="text-gray-500 font-light tracking-wide" data-id="element-162">
              © 2025 Nexyom. Performance. Croissance. Ingénierie.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}